import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ManagementHttpClient } from './management-http-client';

import { QueryStringBuilder } from '@bayclubs/utils';
import { GetInstructorsByClubsIdsQuery, GetInstructorsQuery, InstructorsModel, PayRateSetModel, SetInstructorPayRatesApiCommand } from '@bayclubs/group-classes-employee-api';

@Injectable({
    providedIn: 'root'
})
export class InstructorsApiService {
    constructor(private http: ManagementHttpClient) {}

    public get(criteria: GetInstructorsQuery): Observable<InstructorsModel> {
        const url = `instructors?` + QueryStringBuilder.buildParametersFromSearch(criteria).toString();
        return this.http.get<InstructorsModel>(url, false);
    }

    public getMany(criteria: GetInstructorsByClubsIdsQuery): Observable<InstructorsModel> {
        const url = `instructors/many`;
        return this.http.post<InstructorsModel>(url, criteria, false);
    }

    public getCurrentPayRates(instructorId: string): Observable<PayRateSetModel> {
        const url = `instructors/` + instructorId + '/currentPayRates';
        return this.http.get<PayRateSetModel>(url, true);
    }

    public getPayRates(instructorId: string, includeObsolete: boolean = false): Observable<PayRateSetModel[]> {
        const url = `instructors/` + instructorId + '/payRates?includeObsolete=' + includeObsolete;
        return this.http.get<PayRateSetModel[]>(url, true);
    }

    public savePayRates(
        instructorId: string,
        payRatesSetCommand: SetInstructorPayRatesApiCommand
    ): Observable<void> {
        const url = `instructors/` + instructorId + '/payRates';
        return this.http.put<void>(url, payRatesSetCommand, true);
    }
}
